import React, { useEffect } from 'react';
import './order-notification.css';

export interface IOrderNotificationChildProps {
    onClose: () => void;
    className: string;
}

interface IOrderNotificationProps {
    children: JSX.Element;
    className: string;
}

const OrderNotification = ({
    children,
    className,
}: IOrderNotificationProps) => {
    return (
        <div className={className}>
            <p>{children}</p>
        </div>
    );
};

export default OrderNotification;
